import { render, staticRenderFns } from "./HallsPage.vue?vue&type=template&id=8dcdc494&scoped=true&"
import script from "./HallsPage.vue?vue&type=script&lang=js&"
export * from "./HallsPage.vue?vue&type=script&lang=js&"
import style0 from "./HallsPage.vue?vue&type=style&index=0&id=8dcdc494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcdc494",
  null
  
)

export default component.exports